var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79375 1.79375 0 4 0H20C22.2062 0 24 1.79375 24 4V28C24 30.2062 22.2062 32 20 32H4C1.79375 32 0 30.2062 0 28V4ZM4 9C4 9.55 4.45 10 5 10H19C19.55 10 20 9.55 20 9C20 8.45 19.55 8 19 8H5C4.45 8 4 8.45 4 9ZM5 14C4.45 14 4 14.45 4 15C4 15.55 4.45 16 5 16H19C19.55 16 20 15.55 20 15C20 14.45 19.55 14 19 14H5ZM5 20C4.45 20 4 20.45 4 21C4 21.55 4.45 22 5 22H13C13.55 22 14 21.55 14 21C14 20.45 13.55 20 13 20H5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconText);
export default __webpack_public_path__ + "static/media/icon-text.de004afedd4f9b76ed2ee2341c8642e5.svg";
export { ForwardRef as ReactComponent };